import React, { useState } from "react";
import Header from "./Header";
import Input from "./Input";

const ReviewSearch = ({ getSearchTerm }) => {
  const [searchTerm, setSearchTerm] = useState("");
  getSearchTerm(searchTerm);

  return (
    <section className="search-review">
      <Header title="리뷰 검색" />
      <form>
        <Input
          smallTitle=""
          placeholder="영화 제목을 입력해 주세요"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </form>
      <h1>{searchTerm}</h1>
    </section>
  );
};

export default ReviewSearch;
